import { ReactNode } from "react";
import LoaderSVG from "~/assets/svg/loader.svg?react";
import * as S from "./styles";

type Props = { fullWidth?: boolean; text?: ReactNode };

const Loader = ({ fullWidth, text }: Props) => {
  return (
    <S.LoaderContainer fullWidth={fullWidth} hasText={!!text}>
      <LoaderSVG />
      {/* Optional visible text: a bare spinner is not a contentful element,
          so pages that only show this had no FCP/LCP until real content came. */}
      {text ? <S.LoaderText role="status">{text}</S.LoaderText> : null}
    </S.LoaderContainer>
  );
};

export default Loader;
